
import { io } from 'socket.io-client';
import { reactive } from 'vue'

export const socketConnection = reactive({
  status: 'unknown',  // 'connected' | 'disconnected' | 'unknown'
  latency: null            // solo válido cuando status === 'latency'
})

/**
 * Initializes a Socket.IO connection and updates a shared `connection` object
 * with real-time status and latency information.
 *
 * @param {string} url   - The URL of the Socket.IO server.
 * @param {string} token - Authentication token sent via query parameters.
 * @returns {Socket}      - The initialized Socket.IO client instance.
 *
 * Sets up handlers for:
 *   - 'disconnect': marks status as 'disconnected'
 *   - 'connect':    marks status as 'connected'
 */
function getSocketConnection (url, token) {
  const socket = io(url, {
    transports: ['websocket', 'polling'],
    query: { token },
    reconnection: true,
    reconnectionDelay: 10000,        // tiempo entre intentos: 10s
    reconnectionDelayMax: 30000,     // máximo tiempo entre intentos: 30s
    randomizationFactor: 0.5,        // aleatoriedad entre 50% y 100% del delay
    reconnectionAttempts: Infinity   // reconectar por siempre
  });

  socket.on('disconnect', () => {
    socketConnection.status = 'disconnected'
    socketConnection.latency = null
  });

  socket.on('connect', () => {
    socketConnection.status = 'connected'
    socketConnection.latency = null
  });

  socket.io.on('error', () => {
    if (socketConnection.status === 'unknown') {
      socketConnection.status = 'disconnected';
    }
  });

  socket.io.on('connect_error', () => {
    if (socketConnection.status === 'unknown') {
      socketConnection.status = 'disconnected';
    }
  });

  //TODO: Se debe implementar la logica para calcular la latencia de ser necesario.

  return socket;
}

export default getSocketConnection;
